document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.featured-collections').forEach(function (section) {
    const buttons = section.querySelectorAll('.featured-collections__btn');
    const carousels = section.querySelectorAll('.featured-collections__carousel');
    const viewAllLinks = section.querySelectorAll('.featured-collections__view-all [data-block-id]');
    if (!buttons.length || !carousels.length) return;

    // Tab switching
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const targetId = btn.dataset.target;
        if (!targetId) return;

        buttons.forEach(function (b) {
          const isActive = b === btn;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        carousels.forEach(function (c) {
          const isVisible = c.dataset.blockId === targetId;
          c.classList.toggle('hidden', !isVisible);
          if (isVisible) initDots(c);
        });

        // Keep the "view all" link pointing at the collection now on screen.
        viewAllLinks.forEach(function (link) {
          link.classList.toggle('hidden', link.dataset.blockId !== targetId);
        });
      });
    });

    // Init dots for each visible carousel
    carousels.forEach(function (c) {
      if (!c.classList.contains('hidden')) initDots(c);
    });

    function initDots(carousel) {
      const slider = carousel.querySelector('.slider');
      const dots = carousel.querySelectorAll('.slider-dots__dot');
      const prevBtn = carousel.querySelector('.slider-button--prev');
      const nextBtn = carousel.querySelector('.slider-button--next');
      if (!slider || !dots.length) return;

      function updateActiveDot() {
        const slides = slider.querySelectorAll('.slider__slide');
        if (!slides.length) return;

        let activeIndex = 0;
        const sliderLeft = slider.scrollLeft;
        const sliderWidth = slider.offsetWidth;

        slides.forEach(function (slide, i) {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          if (slideCenter >= sliderLeft && slideCenter <= sliderLeft + sliderWidth) {
            activeIndex = i;
          }
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === activeIndex);
        });
      }

      // Scroll to slide on dot click
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          const slides = slider.querySelectorAll('.slider__slide');
          if (slides[i]) {
            slider.scrollTo({
              left: slides[i].offsetLeft,
              behavior: 'smooth'
            });
          }
        });
      });

      // Update dots on scroll
      let scrollTimeout;
      slider.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveDot, 100);
      });

      // Update dots on prev/next click
      if (prevBtn) prevBtn.addEventListener('click', function () {
        setTimeout(updateActiveDot, 350);
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        setTimeout(updateActiveDot, 350);
      });

      updateActiveDot();
    }
  });
});
